import { useDebouncedValue } from '@mantine/hooks';

// Custom wrapper for mantine useDebouncedValue, which is actually using useEffect on the value,
// it can result in infinite loop when we are debouncing a complex object
// This safe wrapper is to convert the value to a primitive string to avoid the inifinite loop.
export const useDebouncedValueSafe = <T>(
  value: T,
  delay = 300
): [T | undefined, () => void] => {
  const [debounced, cancel] = useDebouncedValue(JSON.stringify(value), delay);

  return [debounced ? (JSON.parse(debounced) as T) : undefined, cancel];
};
